<template>

    <div class="booking">
        <div v-if="!artistId" class="lds-dual-ring"></div>
        <div
            class="booking__box"
            v-for="booking in bookedEventsInfo"
            :key="booking.id"
            v-else
        >
            <div class="booking__title">
                <p class="booking__name">Venue Name: <b class="color_primary"> {{getCompanyName(booking.company_id)}}</b></p>
                <span class="booking__pr">Price:</span>
            </div>
            <div class="booking__inner">
                <div class="booking__row">
                    <div class="booking__col">
                        <h2 class="booking__ttl">FROM / Location</h2>
                        <p>{{ formatDate(booking.from) }}</p>
                        <p><b>{{ booking.start_location}}</b></p>
                    </div>
                    <div class="booking__col">
                        <h2 class="booking__ttl">TO / Location</h2>
                        <p>{{ formatDate(booking.to) }}</p>
                        <p><b>{{ booking.end_location}}</b></p>
                    </div>
                </div>
                <div class="booking__right">
                    <span class="booking__price">$ {{booking.price}}</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import EventsService from "../../services/EventsService";
import {mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import DateHandler from "../../mixins/DateHandler";
import eventsHandler from "../../mixins/eventsHandler";

export default {
    name: 'ArtistBooking',
    data() {
        return {
            bookedEventsInfo: []
        }
    },
    mixins: [DateHandler, eventsHandler],
    computed: {
        ...mapState(useArtistStore, {
            artistId: 'artistId',
            companies: 'companies'
        })
    },
    activated() {
        this.fetchBookingEvents()
    },

    watch: {
       artistId(val) {
           if (val) {
               this.fetchBookingEvents()
           }
       }
    },

    methods: {
        async fetchBookingEvents() {
            try {
                const { data: response } = await EventsService.getBookedEvents(this.artistId)
                this.bookedEventsInfo = response
            } catch (e) {
                console.error(e)
            }
        }
    }

}

</script>

<style scoped>

</style>
